export default __webpack_public_path__ + "static/media/Statistics.941b08a9.png";